"use client"

import { Col, Divider, Layout, Row, Skeleton } from "antd"
import { faFacebook, faTiktok, faInstagramSquare } from "@fortawesome/free-brands-svg-icons"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"

const BasicLayoutFooterSkeleton = () => {
  const isDesktop = useIsDesktop()

  const imagesCard = [
    {
      image: "/static/cards/discover-card.png",
      alt: "Discover card"
    },
    {
      image: "/static/cards/visa-card.png",
      alt: "Visa card"
    },
    {
      image: "/static/cards/mclogo.png",
      alt: "Master card"
    },
    {
      image: "/static/cards/american-express-card.png",
      alt: "American Express Card"
    },
  ]
  return (
    <Layout.Footer
      className='basic_layout--footer'
      style={{ zIndex: 10 }}
    >
      <Row justify="center">
        <Col className="page__section">
          {!isDesktop && (
            <>
              <Row>
                <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: '2.5rem', width: '10rem' } }} />
              </Row>
              <Row style={{ marginBlock: '1rem' }}>
                <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: '1.6rem', width: '50rem' } }} />
              </Row>
            </>
          )}

          <Row align="bottom" justify="space-between">
            <Col sm={{ flex: "auto" }} xs={{ flex: "10rem" }}>
              {isDesktop && (
                <>
                  <Row>
                    <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: '2.5rem', width: '10rem' } }} />
                  </Row>
                  <Row style={{ marginBlock: '1rem' }}>
                    <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: '1.6rem', width: '50rem' } }} />
                  </Row>
                </>
              )}
              <Row align="middle" gutter={5}>
                {imagesCard.map(({ image, alt }) => (
                  <Col key={image}>
                    <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: 25, width: 40 } }} />
                  </Col>
                ))}
              </Row>
            </Col>
            <Col>
              <Row justify="center" wrap={false} style={{ maxWidth: '100%', marginInline: 0 }} gutter={5} align="bottom">
                <Col>
                  <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: 35, width: 35 } }} />
                </Col>
                <Divider orientation="vertical" />
                <Col>
                  {[
                    {
                      key: "about",
                      label: "About",
                      href: "/about",
                    },
                    {
                      key: "contact",
                      label: "Contact",
                    }
                  ]
                    .map((route) => {
                      const text = (
                        <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: '1.6rem', width: '10rem' } }} />
                      )
                      return (
                        <Row justify="center" key={route.key} style={{ cursor: 'pointer', marginTop: '0.5rem' }}>
                          <Col>
                            {text}
                          </Col>
                        </Row>
                      )
                    })}
                  <Row style={{ marginInline: '-2.5px' }} wrap={false}>
                    {[
                      {
                        icon: faFacebook
                      },
                      {
                        icon: faTiktok
                      },
                      {
                        icon: faInstagramSquare
                      },
                    ].map((_, idx) => {
                      return (
                        <Col key={idx} style={{ marginTop: '0.5rem', paddingInline: '2.5px' }}>
                          <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: 35, width: 35 } }} />                            </Col>
                      )
                    })}
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider style={{ marginBlock: '0.5rem' }} />
          <Row style={{ maxWidth: '100%' }} justify="space-between">
            <Col xs={24} sm={{ flex: "auto" }}>
              <Row justify={{ xs: "center", sm: "start" }}>
                <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: '2rem', width: '30rem' } }} />
              </Row>
            </Col>
            <Col xs={24} sm={{ flex: "auto" }}>
              <Row justify={{ sm: 'end', xs: 'center', md: 'end' }}>
                <Col>
                  <Row gutter={5}>
                    <Col>
                      <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: '2rem', width: '10rem' } }} />
                    </Col>
                    <Col>
                      <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: '2rem', width: '10rem' } }} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Layout.Footer>
  )
}

export default BasicLayoutFooterSkeleton